import { Injectable } from '@angular/core';
import { RedirectURL } from '../../model/RedirectURL';
import { StorageService } from '../storage/storage.service';
import { StateService } from '../state/state.service';
import { NonceService } from '../nonce/nonce.service';
import { OidcConfiguration } from '../../model/OidcConfiguration';
import { TokenService } from '../token/token.service';

@Injectable({
  providedIn: 'root'
})
export class OIDCService {

  constructor(
    private storageService: StorageService,
    private stateService : StateService,
    private tokenService : TokenService,
    private nonceService : NonceService
    ) {}



  /**
   * Build the redirect URI
   */
  public buildRedirectURI(): string {
            return  this.authorizeRedirect() ;
  }



/**
 * Forge the authorize request
 *
 */
  private authorizeRedirect(): string {
    var authUrl = RedirectURL.authority + "/authorize?";
    authUrl = authUrl + "client_id=" + encodeURIComponent(RedirectURL.client_id);
    authUrl = authUrl + "&scope=" + encodeURIComponent(RedirectURL.scope);
    authUrl = authUrl + "&response_type=" + encodeURIComponent(RedirectURL.response_type);
    /* if (CASRedirectConfModel['prompt']) {
      authUrl = authUrl + "&prompt=" + encodeURIComponent(CASRedirectConfModel['prompt']);
    } */
    authUrl = authUrl + "&nonce=" + encodeURIComponent(this.nonceService.makeNonce());
    authUrl = authUrl + "&redirect_uri=" + encodeURIComponent(RedirectURL.redirect_uri);
    authUrl = authUrl + "&state=" + encodeURIComponent(this.stateService.makeState());

    return authUrl;
  }



   /**
   * Check if the user is already Authenticated
   */
  public isAuthenticated(): boolean {
    const myAccessToken = this.tokenService.getAccessTokenPayload();

    if (
      myAccessToken == null ||
      typeof myAccessToken == "undefined" ||
      !myAccessToken
    ) {
      return false;
    }
    return true;
  }


  myStorage =
    typeof OidcConfiguration.userStore != "undefined" &&
    OidcConfiguration.userStore
      ? OidcConfiguration.userStore
      : {
          setItem: function() {
            this.log(
              "Storage non configurÃ© : impossible de stocker " +
                arguments +
                " !"
            );
          },
          getItem: function() {
            this.log(
              "Storage non configurÃ© : impossible d'y rÃ©cupÃ©rer " +
                arguments +
                " !"
            );
            return null;
          },
          removeItem: function() {
            this.log(
              "Storage non configurÃ© : impossible de supprimer " +
                arguments +
                " !"
            );
          }
        };


        public fillStorage() {
          // 1. Extraction des paramÃ¨tres de la requÃªte
          // var url = new URL(window.location.href.replace("#", "?"));
          var url = new URL(window.location.href.replace("#", "?"));

          /*  this.loggingService.pushInfo(" access_token = " + url.searchParams.get("access_token"));
          this.loggingService.pushInfo( " token_type = " + url.searchParams.get("token_type") );
          this.loggingService.pushInfo(  " expires_in = " + url.searchParams.get("expires_in") );
          this.loggingService.pushInfo(" id_token = " + url.searchParams.get("id_token") );
          sessionStorage.setItem("HanieAccessToken", url.searchParams.get("access_token") );
          sessionStorage.setItem( "HanieIdTokenToken",  url.searchParams.get("id_token")); */

          // Si un ID token est prÃ©sent dans l'URL on crÃ©e/Ã©crase celui actuellement stockÃ©
          // MÃªme s'il n'est pas pour moi (le 'state' ne correspond pas)
          this.myStorage.setItem(this.storageService.getStorageKey(OidcConfiguration.storageIdtPostfix), url.searchParams.get("id_token"));



          // 2. On vÃ©rifie si la requÃªte est pour nous (paramÃ¨tre 'state')
          var plainState = this.stateService.getState(); // State prÃ©alablement stockÃ©
          var hashedState = url.searchParams.get("state"); // State dans les paramÃ¨tres de la rÃ©ponse
          if (!plainState || typeof hashedState == "undefined" || !hashedState) {
           // this.loggingService.pushInfo("Pas de 'state' : on ne parse pas l'URL");
            return;
          }

          // Si le paramÃ¨tre 'state' correspond, les tokens sont pour moi
          // Sinon ils sont pour un autre RP
          var stateMatches = this.stateService.hashState(plainState) == hashedState;
          // HA. Traitement ID Token
          var id_token = url.searchParams.get("id_token");
          this.putIdTokenOnStorage(id_token,stateMatches) ;

            // HA. Traitement Access Token
          var access_token = url.searchParams.get("access_token");
          this.putATokenOnStorage(access_token) ;
        }


        private putATokenOnStorage(access_token){
          // 4. RÃ©cupÃ©ration de l'Access Token (que ce soit pour moi ou pour un autre client)

          console.log(access_token) ;
          if (typeof access_token != "undefined" && access_token) {
              // Si un access token est prÃ©sent dans l'URL (et que tous les tests prÃ©cÃ©dents sont OK) on crÃ©e/Ã©crase celui actuellement stockÃ©
              this.myStorage.setItem(this.storageService.getStorageKey(OidcConfiguration.storageAtPostfix), access_token);
          }

        }


        private putIdTokenOnStorage(id_token,stateMatches) {


          if (typeof id_token != "undefined" && id_token) {
            // 3. VÃ©rifications obligatoires ssi un ID Token m'est destinÃ©
            if (stateMatches) {
              // Nonce prÃ©alablement stockÃ©
              var plainNonce = this.nonceService.getNonce();
              if (!plainNonce) {
               // this.loggingService.pushInfo("Pas de 'nonce' : on ne parse pas l'URL");
                return;
              }

              // Nonce dans l'ID token
              var idtJson = this.parseJwt(id_token);
              var hashedIdtNonce = idtJson.nonce;

              // Comparaison des nonce
              if (
                typeof hashedIdtNonce == "undefined" ||
                !hashedIdtNonce ||
                this.nonceService.hashNonce(plainNonce) != hashedIdtNonce
              ) {
               // this.loggingService.pushInfo("ParamÃ¨tre nonce incorrect !");
                return;
              }

              // TODO VÃ©rifier la signature
            }

            // Si un ID token est prÃ©sent dans l'URL on crÃ©e/Ã©crase celui actuellement stockÃ©
            // MÃªme s'il n'est pas pour moi (le 'state' ne correspond pas)
            this.myStorage.setItem(
              this.storageService.getStorageKey(OidcConfiguration.storageIdtPostfix),
              id_token
            );
          }

        }

         /**
   * Transforme un JWT base64 en JSON
   */
  // TODO Remplacer par une librairie Ã©prouvÃ©e
  private parseJwt(aToken: any): any {
    var base64Url = aToken.split(".")[1];
    var base64 = base64Url.replace("-", "+").replace("_", "/");
    return JSON.parse(atob(base64));
  }
}
